import { LegalClientSaveGlobalFinancialMonitoringPartOneParam } from 'api/types/params';
import { YesOrNoType } from 'types/yesOrNo';

import { CompanyGlobalFinancialMonitoringPartOneFormType } from '../../forms/companyGlobalFinancialMonitoringPartOneForm';

export const getSubmitData = (
  values: CompanyGlobalFinancialMonitoringPartOneFormType
): LegalClientSaveGlobalFinancialMonitoringPartOneParam => {
  const isSubjectToRegulation =
    values.isSubjectToRegulation?.value === YesOrNoType.Yes;

  if (!isSubjectToRegulation) {
    return { isSubjectToRegulation };
  }

  return {
    isSubjectToRegulation,
    partOneInfo: {
      supervisoryAuthorityNameAndLocation:
        values.supervisoryAuthorityNameAndLocation!,

      hasMandatoryAmlRegulations:
        values.mandatoryAmlRegulation?.hasMandatoryAmlRegulations?.value ===
        YesOrNoType.Yes,

      mandatoryAmlRegulation:
        values.mandatoryAmlRegulation?.hasMandatoryAmlRegulations?.value ===
        YesOrNoType.Yes
          ? {
              regulationDetails:
                values.mandatoryAmlRegulation.regulationDetails!,
              authorizedBodyName:
                values.mandatoryAmlRegulation.authorizedBodyName!,
            }
          : undefined,

      lastAmlAuditResult: values.lastAmlAuditResult,

      hadInvestigationsOrSanctions:
        values.investigationsOrSanctions?.hadInvestigationsOrSanctions
          ?.value === YesOrNoType.Yes,
      amlDecisionDateAndAuthorityInfo:
        values.investigationsOrSanctions?.hadInvestigationsOrSanctions
          ?.value === YesOrNoType.Yes
          ? values.investigationsOrSanctions.amlDecisionDateAndAuthorityInfo
          : undefined,

      hasInternalAmlDocuments:
        values.internalAmlDocuments?.hasInternalAmlDocuments?.value ===
        YesOrNoType.Yes,

      internalAmlDocuments:
        values.internalAmlDocuments?.hasInternalAmlDocuments?.value ===
        YesOrNoType.Yes
          ? {
              adoptionDate: values.internalAmlDocuments.adoptionDate!,
              lastUpdateDate: values.internalAmlDocuments.lastUpdateDate!,
              hasEffectivenessAssessmentProcedures:
                values.internalAmlDocuments.hasEffectivenessAssessmentProcedures
                  ?.value === YesOrNoType.Yes,
              lastEffectivenessCheckInfo:
                values.internalAmlDocuments.hasEffectivenessAssessmentProcedures
                  ?.value === YesOrNoType.Yes
                  ? values.internalAmlDocuments.lastEffectivenessCheckInfo
                  : undefined,
              appliesToForeignAffiliates:
                values.internalAmlDocuments.appliesToForeignAffiliates
                  ?.value === YesOrNoType.Yes,
            }
          : undefined,

      hasDepartmentsResponsibleForAmlFunctions:
        values.departmentsResponsibleForAmlFunctions
          ?.hasDepartmentsResponsibleForAmlFunctions?.value === YesOrNoType.Yes,
      amlFunctionDepartmentsNames:
        values.departmentsResponsibleForAmlFunctions
          ?.hasDepartmentsResponsibleForAmlFunctions?.value === YesOrNoType.Yes
          ? values.departmentsResponsibleForAmlFunctions
              .amlFunctionDepartmentsNames
          : undefined,

      hasResponsibleAmlManager:
        values.responsibleAmlManager?.hasResponsibleAmlManager?.value ===
        YesOrNoType.Yes,

      responsibleAmlManager:
        values.responsibleAmlManager?.hasResponsibleAmlManager?.value ===
        YesOrNoType.Yes
          ? {
              fullName: values.responsibleAmlManager.fullName!,
              position: values.responsibleAmlManager.position!,
              email: values.responsibleAmlManager.email!,
              phoneNumber: values.responsibleAmlManager.phoneNumber!,
            }
          : undefined,

      hasRiskManagementProcedures:
        values.hasRiskManagementProcedures?.value === YesOrNoType.Yes,
    },
  };
};
